import ChatMessagesWindow from "./ChatMessagesWindow";

export default ChatMessagesWindow;
